import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField  from "../../../../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  tabroot: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  });

const SkillViewDesc = ({desc}) => {
  const {tabroot, heading } = useStyles();

  return (
    <div className={tabroot}>
      <Typography className={heading}>Описание</Typography>
      <TextField
        value={desc}
        label=""
        readOnly
        multiline
      />
    </div>
  );
};

export default SkillViewDesc;
